import { render } from "./nav_cart.vue?vue&type=template&id=4d3278cf"
import script from "./nav_cart.vue?vue&type=script&lang=js"
export * from "./nav_cart.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__